// react
import { useCallback, useEffect, useMemo } from 'react';
import styled from 'styled-components';

// components
import { Typeform } from '@/components/organisms';
import {
  GenericFlowProps,
  OnboardingActions,
  OnboardingActionType,
  toGenericOnboarding,
} from '@/components/pages/OnboardingFlow/OnboardingFlow';

export const OnboardingTypeform = toGenericOnboarding(
  ({
    setIsNextDisabled,
    config,
    currentIndex = 0,
    handleClick,
  }: GenericFlowProps<OnboardingTypeformConfigItem>) => {
    return (
      <>
        {config[currentIndex]?.formID && (
          <Typeform
            formID={config?.[0]?.formID}
            onSubmit={() => handleClick?.(OnboardingActionType.Next)}
          />
        )}
      </>
    );
  },
);

const Wrapper = styled.div`
  height: 100%;
  padding: ${(props) => props.theme.spacing[32]} 0;
`;

export interface OnboardingTypeformConfigItem extends OnboardingActions {
  formID: string;
}

OnboardingTypeform.displayName = 'OnboardingTypeform';
export default toGenericOnboarding(OnboardingTypeform);
